/**
 * Online mean + variance accumulator (Welford). Avoids storing series.
 * Provides serializeWelford / deserializeWelford for sessionStorage round-trips.
 */

export function createWelford() {
  return { n: 0, mean: 0, m2: 0, min: Infinity, max: -Infinity };
}

export function welfordAdd(w, x) {
  if (!Number.isFinite(x)) return;
  w.n += 1;
  const delta = x - w.mean;
  w.mean += delta / w.n;
  const delta2 = x - w.mean;
  w.m2 += delta * delta2;
  if (x < w.min) w.min = x;
  if (x > w.max) w.max = x;
}

export function welfordVariance(w) {
  return w.n > 1 ? w.m2 / (w.n - 1) : 0;
}

export function welfordSummary(w) {
  if (w.n === 0) {
    return { count: 0, avg: 0, var: 0, min: 0, max: 0 };
  }
  return { count: w.n, avg: w.mean, var: welfordVariance(w), min: w.min, max: w.max };
}

export function serializeWelford(w) {
  return { n: w.n, mean: w.mean, m2: w.m2, min: w.min, max: w.max };
}

export function deserializeWelford(o) {
  const w = createWelford();
  if (!o || typeof o !== 'object') return w;
  if (Number.isFinite(o.n)) w.n = o.n;
  if (Number.isFinite(o.mean)) w.mean = o.mean;
  if (Number.isFinite(o.m2)) w.m2 = o.m2;
  if (Number.isFinite(o.min)) w.min = o.min;
  if (Number.isFinite(o.max)) w.max = o.max;
  return w;
}
